import deserialize from 'app/utils/deserialize'
import FormErrors from 'app/utils/form_errors'
import { fetch, create } from 'app/utils/data'
import { get } from 'lodash'

export default {
  namespaced: true,

  state: {
    item: null
  },

  mutations: {
    accountConfirmationFetched(state, { accountConfirmation }) {
      state.item = accountConfirmation
    },

    resetState(state) {
      state.item = null
    }
  },

  getters: {
    accountConfirmation(state) {
      return state.item
    }
  },

  actions: {
    /**
     * Takes the email and confirmation token provided in the account confirmation email and gets the account confirmation
     * data. The data is deserialized and commited to the vuex store for use in the remainder of the workflow.
     *
     * Details:
     * Vuex commit function is passed in by caller and made available via destructuring assignment.
     * Email and confirmation token are passed in by the caller.
     * Function calls {@link ../../utils/data.js#fetch} and awaits response.
     * Response is deserialized and the account confirmation object is passed to the vuex commit object.
     * Account confirmation is committed to the accountConfirmationFetched variable.
     *
     * Convenience Links:
     * {@link https://v3.vuex.vuejs.org/guide/actions.html Vuex Actions}
     *
     * @function fetchAccountConfirmation
     * @param {Object} param0 - The Vuex commit object
     * @param {import('vuex').Commit} param0.commit - The Vuex commit object
     * @param {Object} param1 - The account confirmation data
     * @param {string} param1.email - The users email address
     * @param {string} param1.confirmationToken - The confirmation token provided for confirmation
     * @returns {Object} - The response to the account confirmation request
     */
    fetchAccountConfirmation({ commit }, { email, confirmationToken, inviteToken }) {
      return new Promise((resolve, reject) => {
        fetch({
          url: '/api/account-confirmations',
          type: 'account-confirmation',
          params: {
            'filter[confirmation-token]': confirmationToken,
            'filter[email]': email,
            'filter[invite-token]': inviteToken
          }
        })
          .then((response) => {
            deserialize(response.data).then((accountConfirmation) => {
              commit('accountConfirmationFetched', { accountConfirmation })
              resolve()
            })
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    confirmAccount({ commit, state }, changes) {
      return new Promise((resolve, reject) => {
        create({
          url: '/api/account-confirmations',
          type: 'account-confirmation',
          data: Object.assign(changes, { id: state.item.id })
        })
          .then((response) => {
            if (response.headers['auth-token']) {
              commit('sessions/tokenFetched', response.headers['auth-token'], { root: true })
            }

            deserialize(response.data).then((_accountConfirmation) => {
              commit('resetState')
              resolve()
            })
          })
          .catch((error) => {
            if (get(error, ['response', 'data', 'errors'], null)) {
              reject(new FormErrors(error.response.data.errors))
            } else {
              reject(new FormErrors([{ detail: 'Something went wrong.' }]))
            }
          })
      })
    }
  }
}
